export const Content1DataSource = {
  wrapper: { className: 'home-page-wrapper test-content1-wrapper' },
  page: { className: 'home-page test-content1' },
  OverPack: { playScale: 0.1 },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        className: 'title-h1',
        children: 'product.test.platform'
      },
      {
        name: 'sub-title',
        className: 'sub-title',
        children: 'Automated Testing'
      },
      {
        name: 'content',
        className: 'content',
        children: 'product.test.introduce'
      }
    ]
  }
};
export const Content2DataSource = {
  wrapper: { className: 'home-page-wrapper test-content2-wrapper' },
  page: { className: 'home-page test-content2' },
  OverPack: { playScale: 0.1 },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        className: 'title-h1',
        children: 'product.test.solution'
      },
      {
        name: 'sub-title',
        className: 'sub-title',
        children: 'SOLUTION'
      }
    ]
  }
};

export const Content3DataSource = {
  wrapper: { className: 'home-page-wrapper test-content3-wrapper' },
  page: { className: 'home-page test-content3' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      { name: 'title', className: 'title-h1', children: 'product.test.applicationScenario' },
      { name: 'sub-title', className: 'sub-title', children: 'APPLICATION SCENARIO' }
    ]
  },
  childWrapper: {
    className: 'test-content3-block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'test-content3-block',
        active: true,
        children: {
          className: 'test-content3-block-item',
          img: 'test-03.png',
          title: 'product.test.applicationScenarioTitle01',
          children: [
            {
              name: 'content',
              className: 'test-content3-block-content',
              children: 'product.test.applicationScenario01Content01'
            },
            {
              name: 'content',
              className: 'test-content3-block-content',
              children: 'product.test.applicationScenario01Content02'
            },
            {
              name: 'content',
              className: 'test-content3-block-content',
              children: 'product.test.applicationScenario01Content03'
            }
          ]
        }
      },
      {
        name: 'block1',
        className: 'test-content3-block',
        active: true,
        children: {
          className: 'test-content3-block-item',
          img: 'test-04.png',
          title: 'product.test.applicationScenarioTitle02',
          children: [
            {
              name: 'content',
              className: 'test-content3-block-content',
              children: 'product.test.applicationScenario02Content01'
            },
            {
              name: 'content',
              className: 'test-content3-block-content',
              children: 'product.test.applicationScenario02Content02'
            },
            {
              name: 'content',
              className: 'test-content3-block-content',
              children: 'product.test.applicationScenario02Content03'
            },
            {
              name: 'content',
              className: 'test-content3-block-content',
              children: 'product.test.applicationScenario02Content04'
            }
          ]
        }
      }, {
        name: 'block2',
        className: 'test-content3-block',
        active: true,
        children: {
          className: 'test-content3-block-item',
          img: 'test-05.png',
          title: 'product.test.applicationScenarioTitle03',
          children: [
            {
              name: 'content',
              className: 'test-content3-block-content',
              children: 'product.test.applicationScenario03Content01'
            }, {
              name: 'content',
              className: 'test-content3-block-content',
              children: 'product.test.applicationScenario03Content02'
            }, {
              name: 'content',
              className: 'test-content3-block-content',
              children: 'product.test.applicationScenario03Content03'
            }
          ]
        }
      }
    ]
  }
};
